<template>
  <validationObserver ref="componentForm" tag="form">
    <b-table
      ref="dimensaionTable"
      class="line-height striped"
      head-variant="light"
      :empty-text="'ไม่พบข้อมูล'"
      :show-empty="
        items === null || items === undefined || (items && items.length === 0)
      "
      :striped="false"
      :bordered="true"
      v-bind:items="items"
      v-bind:fields="fields"
    >
      <template v-slot:cell(index)="data">
        {{ (data.index + 1) | number }}
      </template>
      <template v-slot:cell(units)="data">
        {{ `${data.value.display_name.th} : ${data.value.display_name.en}` }}
      </template>
      <template #cell(action)="row">
        <button
          class="btn btn-sm btn-info"
          type="button"
          style="width:111%"
          @click="row.toggleDetails"
        >
          {{ row.detailsShowing ? 'Hide' : 'More' }}
          <i
            :class="
              row.detailsShowing ? 'bx bx-caret-down' : 'bx bx-caret-right'
            "
            title="More Detail"
          ></i>
        </button>
      </template>
      <template #row-details="row">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              {{
                `${row.item.units.display_name.th} : ${row.item.units.display_name.en}`
              }}
            </h4>
            <div class="pt-3">
              <div class="row">
                <div class="col-12">
                  <div class="border-top pb-4"></div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-row">
                    <label class="col-sm-2 col-form-label" for="display_name_en"
                      >หน่วย</label
                    >
                    <div class="col">
                      <div class="row">
                        <div class="col-sm-3 col mt-auto mb-auto">
                          <div class="relative form-group">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              :value="
                                `${row.item.units.display_name.th} : ${row.item.units.display_name.en}`
                              "
                            />
                          </div>
                        </div>
                        <label class="col-sm-3 col-form-label">
                          จำนวนชิ้น/หน่วยบรรจุ
                        </label>
                        <div class="col-sm-3 col mt-auto mb-auto">
                          <div class="relative form-group">
                            <input
                              disabled
                              type="text"
                              class="form-control text-right"
                              :value="row.item.unit_of_measurement"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >ขนาดสินค้า (ก x ย x ส)
                      <i
                        class="ml-1 bx bx-info-circle align-middle absolute text-grey f-18"
                        id="tooltip-factor-width"
                      />
                      <b-tooltip
                        target="tooltip-factor-width"
                        placement="right"
                        variant="info"
                        >หากไม่ทราบขนาดสินค้า (ก x ย x ส) กรุณาระบุค่าไว้ที่
                        1</b-tooltip
                      >
                    </label>
                    <div class="col">
                      <div class="row">
                        <div class="col-sm-3">
                          <validationProvider
                            v-slot="{ errors }"
                            name="width_size_value"
                            :rules="{
                              validateGreaterThanZero: true,
                              dynamicRequired: ['กรุณาระบุข้อมูล'],
                            }"
                          >
                            <input
                              id="width_size_value"
                              name="width_size_value"
                              type="text"
                              class="form-control text-right"
                              v-model="editItems[row.index].width_size_value"
                              @input="
                                editItems[
                                  row.index
                                ].width_size_value = validateDecimalWithModel(
                                  editItems[row.index].width_size_value,
                                  editItems[row.index].size_type === 'CM'
                                    ? 2
                                    : 0,
                                  9999999
                                )
                              "
                              @change="calculateCBMAndFee(editItems[row.index])"
                              :class="{ 'is-invalid': errors.length }"
                              :disabled="
                                editItems[row.index].size_type === '' ||
                                  dataPermissions.find(
                                    f => f.name === 'dimensions'
                                  ).isEditable === false
                              "
                            />
                            <span
                              v-if="errors.length"
                              class="validate-invalid bt-22"
                            >
                              {{ errors[0] }}
                            </span>
                          </validationProvider>
                        </div>
                        <div class="col-sm-3">
                          <validationProvider
                            v-slot="{ errors }"
                            name="length_size_value"
                            :rules="{
                              validateGreaterThanZero: true,
                              dynamicRequired: ['กรุณาระบุข้อมูล'],
                            }"
                          >
                            <input
                              id="length_size_value"
                              name="length_size_value"
                              type="text"
                              class="form-control text-right"
                              @input="
                                editItems[
                                  row.index
                                ].length_size_value = validateDecimalWithModel(
                                  editItems[row.index].length_size_value,
                                  editItems[row.index].size_type === 'CM'
                                    ? 2
                                    : 0,
                                  9999999
                                )
                              "
                              v-model="editItems[row.index].length_size_value"
                              @change="calculateCBMAndFee(editItems[row.index])"
                              :class="{ 'is-invalid': errors.length }"
                              :disabled="
                                editItems[row.index].size_type === '' ||
                                  dataPermissions.find(
                                    f => f.name === 'dimensions'
                                  ).isEditable === false
                              "
                            />
                            <span
                              v-if="errors.length"
                              class="validate-invalid bt-22"
                            >
                              {{ errors[0] }}
                            </span>
                          </validationProvider>
                        </div>
                        <div class="col-sm-3">
                          <validationProvider
                            v-slot="{ errors }"
                            name="height_size_value"
                            :rules="{
                              validateGreaterThanZero: true,
                              dynamicRequired: ['กรุณาระบุข้อมูล'],
                            }"
                          >
                            <input
                              id="height_size_value"
                              name="height_size_value"
                              type="text"
                              class="form-control text-right"
                              @input="
                                editItems[
                                  row.index
                                ].height_size_value = validateDecimalWithModel(
                                  editItems[row.index].height_size_value,
                                  editItems[row.index].size_type === 'CM'
                                    ? 2
                                    : 0,
                                  9999999
                                )
                              "
                              v-model="editItems[row.index].height_size_value"
                              @change="calculateCBMAndFee(editItems[row.index])"
                              :class="{ 'is-invalid': errors.length }"
                              :disabled="
                                editItems[row.index].size_type === '' ||
                                  dataPermissions.find(
                                    f => f.name === 'dimensions'
                                  ).isEditable === false
                              "
                            />
                            <span
                              v-if="errors.length"
                              class="validate-invalid bt-22"
                            >
                              {{ errors[0] }}
                            </span>
                          </validationProvider>
                        </div>
                        <div class="col-sm-3">
                          <validationProvider
                            v-slot="{ errors }"
                            name="dimension_options"
                            :rules="{
                              dynamicRequired: ['กรุณาเลือก'],
                            }"
                          >
                            <multiselect
                              v-model="editItems[row.index].size_type"
                              :options="
                                options_dimension.map(type => type.value)
                              "
                              :custom-label="
                                label =>
                                  options_dimension.find(x => x.value == label)
                                    .text
                              "
                              @input="
                                onChangeWidthSizeType(editItems[row.index])
                              "
                              :class="{ 'is-invalid': errors.length }"
                              :show-labels="false"
                              :disabled="
                                dataPermissions.find(
                                  f => f.name === 'dimensions'
                                ).isEditable === false
                              "
                              placeholder="กรุณาเลือก"
                            ></multiselect>
                            <span
                              v-if="errors.length"
                              class="validate-invalid bt-22"
                            >
                              {{ errors[0] }}
                            </span>
                          </validationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >น้ำหนัก
                      <i
                        class="ml-1 bx bx-info-circle align-middle absolute text-grey f-18"
                        id="tooltip-factor-weight"
                      />
                      <b-tooltip
                        target="tooltip-factor-weight"
                        placement="right"
                        variant="info"
                        >หากไม่ทราบนํ้าหนักกรุณาระบุค่าไว้ที่ 1</b-tooltip
                      >
                    </label>
                    <div class="col">
                      <div class="row">
                        <div class="col-sm-3">
                          <validationProvider
                            v-slot="{ errors }"
                            name="weight_value"
                            :rules="{
                              validateGreaterThanZero: true,
                              dynamicRequired: ['กรุณาระบุข้อมูล'],
                            }"
                          >
                            <input
                              id="weight_value"
                              name="weight_value"
                              type="text"
                              class="form-control text-right"
                              @input="
                                editItems[
                                  row.index
                                ].weight_value = validateDecimalWithModel(
                                  editItems[row.index].weight_value,
                                  editItems[row.index].weight_type === 'KG'
                                    ? 2
                                    : 0,
                                  9999999
                                )
                              "
                              v-model="editItems[row.index].weight_value"
                              @change="
                                calculatePreDeliveryFee(editItems[row.index])
                              "
                              :class="{ 'is-invalid': errors.length }"
                              :disabled="
                                editItems[row.index].weight_type === '' ||
                                  dataPermissions.find(
                                    f => f.name === 'dimensions'
                                  ).isEditable === false
                              "
                            />
                            <span
                              v-if="errors.length"
                              class="validate-invalid bt-22"
                            >
                              {{ errors[0] }}
                            </span>
                          </validationProvider>
                        </div>
                        <div class="col-sm-3">
                          <validationProvider
                            v-slot="{ errors }"
                            name="weight_type"
                            :rules="{ dynamicRequired: ['กรุณาระบุข้อมูล'] }"
                          >
                            <multiselect
                              v-model="editItems[row.index].weight_type"
                              :options="
                                options_weight_type.map(type => type.value)
                              "
                              :custom-label="
                                label =>
                                  options_weight_type.find(
                                    x => x.value == label
                                  ).text
                              "
                              @input="onChangeWeightType(editItems[row.index])"
                              :class="{ 'is-invalid': errors.length }"
                              :show-labels="false"
                              :disabled="
                                dataPermissions.find(
                                  f => f.name === 'dimensions'
                                ).isEditable === false
                              "
                              placeholder="กรุณาเลือก"
                            ></multiselect>
                            <span
                              v-if="errors.length"
                              class="validate-invalid bt-22"
                            >
                              {{ errors[0] }}
                            </span>
                          </validationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-row"
                    v-if="userInfo.user_type === 'Operator'"
                  >
                    <label class="col-sm-2 col-form-label"
                      >ปริมตรสินค้าต่อการจัดส่ง</label
                    >
                    <div class="col">
                      <div class="row">
                        <div class="col-sm-3 col mt-auto mb-auto">
                          <div class="relative form-group">
                            <input
                              disabled
                              type="text"
                              class="form-control text-right"
                              :value="editItems[row.index].delivery_cubic_meter"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-row"
                    v-if="userInfo.user_type === 'Operator'"
                  >
                    <label class="col-sm-2 col-form-label">ค่าจัดส่ง</label>
                    <div class="col">
                      <div class="row">
                        <div class="col-sm-3 col mt-auto mb-auto">
                          <div class="relative form-group">
                            <validationProvider
                              v-slot="{ errors }"
                              name="delivery_fee"
                              :rules="{
                                dynamicRequired: ['กรุณาระบุข้อมูล'],
                              }"
                            >
                              <!-- <input
                                id="delivery_fee"
                                name="delivery_fee"
                                type="text"
                                class="form-control text-right"
                                @keydown="validateNum($event)"
                                v-model="editItems[row.index].delivery_fee"
                                :class="{ 'is-invalid': errors.length }"
                                :disabled="
                                  dataPermissions.find(
                                    f => f.name === 'dimensions'
                                  ).isEditable === false
                                "
                              /> -->
                              <InputFormatDecimal
                                name="delivery_fee"
                                v-model="editItems[row.index].delivery_fee"
                                :isError="errors && errors.length > 0"
                                :disabled="
                                  dataPermissions.find(
                                    f => f.name === 'dimensions'
                                  ).isEditable === false
                                "
                              />
                              <span
                                v-if="errors.length"
                                class="validate-invalid bt-22"
                              >
                                {{ errors[0] }}
                              </span>
                            </validationProvider>
                          </div>
                        </div>
                        <label
                          class="col-sm-3 col-form-label"
                          for="delivery_fee"
                        >
                          ค่าจัดส่งแนะนำ
                        </label>
                        <div class="col-sm-3">
                          <div class="relative form-group">
                            <!-- <input
                              disabled
                              type="text"
                              class="form-control text-right"
                              :value="editItems[row.index].fee"
                            /> -->
                            <InputFormatDecimal
                              disabled
                              :value="editItems[row.index].fee"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-row form-group"
                    v-if="userInfo.user_type === 'Operator'"
                  >
                    <label class="col-lg-4 col-xl-3 col-form-label"
                      >มีค่าจัดส่งพิเศษ</label
                    >
                    <div class="col-sm-9 col-form-label">
                      <switches
                        v-model="editItems[row.index].is_extra_shipping_fee"
                        type-bold="true"
                        color="info"
                        class="switch-inner-label custom-switches switches-small"
                        text-enabled="Yes"
                        text-disabled="No"
                        :disabled="
                          dataPermissions.find(f => f.name === 'dimensions')
                            .isEditable === false
                        "
                      />
                    </div>
                  </div>
                  <div
                    class="form-row form-group"
                    v-if="userInfo.user_type === 'Operator'"
                  >
                    <label class="col-lg-4 col-xl-3 col-form-label"
                      >ร่วมบริการจัดส่งแบบ Click and Collect</label
                    >
                    <div class="col-sm-9 col-form-label">
                      <switches
                        v-model="editItems[row.index].is_click_and_collect"
                        type-bold="true"
                        color="info"
                        class="switch-inner-label custom-switches switches-small"
                        text-enabled="Yes"
                        text-disabled="No"
                        :disabled="
                          dataPermissions.find(f => f.name === 'dimensions')
                            .isEditable === false
                        "
                      />
                    </div>
                  </div>
                  <div
                    class="form-row form-group"
                    v-if="userInfo.user_type === 'Operator'"
                  >
                    <label class="col-lg-4 col-xl-3 col-form-label"
                      >จัดส่งสินค้าโดย OFM</label
                    >
                    <div class="col-sm-9 col-form-label">
                      <switches
                        v-model="editItems[row.index].is_ofm_delivery"
                        type-bold="true"
                        color="info"
                        class="switch-inner-label custom-switches switches-small"
                        text-enabled="Yes"
                        text-disabled="No"
                        :disabled="
                          dataPermissions.find(f => f.name === 'dimensions')
                            .isEditable === false
                        "
                      />
                    </div>
                  </div>
                  <!-- <div
                    class="form-row form-group"
                    v-if="userInfo.user_type === 'Operator'"
                  >
                    <label class="col-lg-4 col-xl-3 col-form-label"
                      >จัดส่งสินค้าโดย OFM</label
                    >
                    <div class="col-sm-9 col-form-label">
                      <switches
                        v-model="editItems[row.index].is_ofm_delivery"
                        type-bold="true"
                        color="info"
                        class="switch-inner-label custom-switches switches-small"
                        text-enabled="Yes"
                        text-disabled="No"
                        :disabled="
                          dataPermissions.find(f => f.name === 'dimensions')
                            .isEditable === false
                        "
                      />
                    </div>
                  </div> -->
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    v-if="
                      dataPermissions.find(f => f.name === 'dimensions')
                        .isEditable === true
                    "
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="updateItem(row)"
                  >
                    <i class="bx bx-save" />
                    Update
                  </button>
                  <button
                    type="button"
                    class="btn btn-light btn-sm"
                    @click="row.toggleDetails"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-table>
  </validationObserver>
</template>
<script>
//Helpers
import { FormatQty } from '@/helpers/utils/format-qty.js'
import productRegisterService from '@/helpers/service/product-register-service'
import { calculateDeliveryFee } from '@/helpers/utils/product'
import validate from '@/helpers/utils/validate.js'
import Multiselect from 'vue-multiselect'
import { getUserInfo } from '@/helpers/utils/jwt'
import InputFormatDecimal from '@/components/share/input-decimal-format.vue'

//Vue Component Install
import Switches from 'vue-switches'

//Components
import { authComputed } from '@/state/helpers'

export default {
  name: 'TableDimension',
  components: {
    Multiselect,
    Switches,
    InputFormatDecimal,
  },
  mixins: [validate],
  props: {
    value: {
      type: Array,
      default: () => {
        return this.items
      },
    },
    skus: {
      type: Array,
      default: () => [],
    },
    vendor_type: {
      type: String,
      default: '',
    },
    inventoryId: {
      type: String,
      default: () => {
        return ''
      },
    },
    is_free: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: '#',
          thClass: 'w-50-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'units',
          label: 'หน่วยของสินค้า',
          thClass: '',
          tdClass: '',
          sortable: false,
        },
        {
          key: 'weight_value',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'น้ำหนัก',
          class: 'w-90-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'weight_type',
          label: 'หน่วย',
          class: 'w-90-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'width_size_value',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ความกว้าง',
          class: 'w-90-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'length_size_value',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ความยาว',
          class: 'w-90-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'height_size_value',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ความสูง',
          class: 'w-90-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'size_type',
          label: 'หน่วย',
          class: 'w-90-px',
          tdClass: 'text-center',
          sortable: false,
        },
        {
          key: 'action',
          label: 'Action',
          class: 'w-90-px',
          tdClass: 'text-center',
          sortable: false,
        },
      ],
      items: [],
      editItems: [],
      options_weight_type: [
        { value: 'KG', text: 'กิโลกรัม | Kilogram' },
        { value: 'G', text: 'กรัม | Gram' },
      ],
      options_dimension: [
        { value: 'CM', text: 'เซนติเมตร | Centimeter' },
        { value: 'MM', text: 'มิลลิเมตร | Millimeter' },
      ],
      permissions: [
        {
          name: 'dimensions',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
      ],
      timerCount: 10,
      delivery_type: '',
      deliveryTypeOptions: [],
      isFirstWatchValue: true,
    }
  },
  created() {
    if (this.isFirstWatchValue) {
      if (this.value && this.value.length > 0) {
        this.items = this.value
        this.editItems = Object.assign([], this.value)
      } else {
        this.mappingData(this.productSkus)
      }
    }
  },
  computed: {
    ...authComputed,
    userInfo() {
      if (this.getAccessToken !== null) {
        return getUserInfo(this.getAccessToken)
      } else return {}
    },
    productSkus() {
      let productSkus = []
      if (this.skus && this.skus.length > 0) {
        let groupUnits = this.skus.reduce((r, a) => {
          r[
            a.skuModel.mechanics.find(s => s.collection === 'unit').value.id
          ] = [
            ...(r[
              a.skuModel.mechanics.find(s => s.collection === 'unit').value.id
            ] || []),
            a,
          ]
          return r
        }, {})
        let groupUnitsValues = Object.values(groupUnits)
        productSkus = groupUnitsValues.map(m => m[0].skuModel)
      }
      return productSkus
    },
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter(f => f.my_process_action.can_edit === true)
          .map(m => m.rule_id)

        permissions
          .filter(f => f.ruleIDs.some(s => ruleEditables.some(r => r === s)))
          .forEach(element => {
            element.isEditable = true
          })
      } else {
        permissions.forEach(element => {
          element.isEditable = this.is_view ? false : true
        })
      }
      return permissions
    },
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--
            // console.log(this.timerCount)
          }, 1000)
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
    inventoryId: {
      handler(val) {
        if (val && val !== '') {
          this.getDeliveryTypeByInventory(val)
        }
      },
      deep: true,
    },
    vendor_type: {
      handler(val) {
        if (val && val === 'DropShip') {
          this.editItems.forEach(element => {
            this.calculatePreDeliveryFee(element)
          })
        }
      },
      deep: true,
    },
    productSkus: {
      handler(val) {
        if (this.checkDataChange(val)) {
          this.mappingData(val)
        }
        if (this.inventoryId && this.inventoryId !== '') {
          this.getDeliveryTypeByInventory(this.inventoryId)
        }
      },
    },
    value: {
      handler(val) {
        if (this.isFirstWatchValue) {
          this.items = val
          this.editItems = Object.assign([], val)
          this.isFirstWatchValue = false
        }
      },
      deep: true,
    },
  },
  methods: {
    modelChanged() {
      this.$emit('input', this.items)
    },
    async getDeliveryTypeByInventory(id) {
      let params = new URLSearchParams()
      params.append('id', id)
      let result = await productRegisterService.getDeliveryTypeByInventoryAsync(
        params
      )
      if (result.status === 200) {
        this.delivery_type = result.data
      } else {
        this.delivery_type = ''
      }
    },
    checkDataChange(val) {
      if (val.length === 0) {
        if (this.timerCount === 0) {
          this.items = []
          this.editItems = []
          this.modelChanged()
        }
        return false
      } else if (
        val.some(
          f =>
            !this.items.some(
              s =>
                s.units.id ===
                f.mechanics.find(m => m.collection === 'unit').value.id
            )
        )
      ) {
        return true
      } else if (
        this.items.some(
          f =>
            !val.some(
              s =>
                s.mechanics.find(m => m.collection === 'unit').value.id ===
                f.units.id
            )
        )
      ) {
        return true
      } else if (this.items.length !== this.productSkus.length) {
        return true
      } else {
        return false
      }
    },
    genDiamissionsFromSKUs(val) {
      return val.map(s => {
        return s.mechanics.some(s => s.collection === 'unit')
          ? {
              units: {
                id: s.mechanics.find(s => s.collection === 'unit').value.id,
                display_name: s.mechanics.find(s => s.collection === 'unit')
                  .value.display_name,
                short_name: s.mechanics.find(s => s.collection === 'unit').value
                  .display_name,
              },
              weight_value: 0,
              weight_type: '',
              width_size_value: 0,
              length_size_value: 0,
              height_size_value: 0,
              size_type: '',
              unit_of_measurement: 1,
              delivery_cubic_meter: 0.0,
              delivery_fee: 0.0,
              is_ofm_delivery: true,
              is_extra_shipping_fee: false,
              is_click_and_collect: false,
              barcode: '',
              type: 'Piece',
              fee: 0,
            }
          : {
              units: {
                id: '',
                display_name: { en: '', th: '' },
                short_name: { en: '', th: '' },
              },
              weight_value: 0,
              weight_type: '',
              width_size_value: 0,
              length_size_value: 0,
              height_size_value: 0,
              size_type: '',
              unit_of_measurement: 1,
              delivery_cubic_meter: 0.0,
              delivery_fee: 0.0,
              is_ofm_delivery: true,
              is_extra_shipping_fee: false,
              is_click_and_collect: false,
              barcode: '',
              type: 'Piece',
              fee: 0,
            }
      })
    },
    mappingData(val) {
      if (val && val.length > 0) {
        this.items = this.genDiamissionsFromSKUs(val)
        this.editItems = Object.assign([], this.genDiamissionsFromSKUs(val))
      }
    },
    updateItem(row) {
      this.$refs.componentForm.validate().then(result => {
        if (result) {
          row.item._showDetails = false
          this.items[row.index] = Object.assign({}, this.editItems[row.index])
          this.modelChanged()
          this.$refs.dimensaionTable.refresh()
        }
      })
    },
    onChangeWidthSizeType(item) {
      item.width_size_value = 0
      item.length_size_value = 0
      item.height_size_value = 0
      this.calculateCBMAndFee(item)
    },
    onChangeWeightType(item) {
      item.weight_value = 0
      this.calculateCBMAndFee(item)
    },
    calculateCBMAndFee(item) {
      let width_size_value =
        item.size_type === 'MM'
          ? Number(item.width_size_value)
          : Number(item.width_size_value) * 10

      let length_size_value =
        item.size_type === 'MM'
          ? Number(item.length_size_value)
          : Number(item.length_size_value) * 10

      let height_size_value =
        item.size_type === 'MM'
          ? Number(item.height_size_value)
          : Number(item.height_size_value) * 10

      // var numb =
      //   ((width_size_value / 10.0) *
      //     (length_size_value / 10.0) *
      //     (height_size_value / 10.0)) /
      //   1000000.0

      // item.delivery_cubic_meter =
      //   Math.round((numb + Number.EPSILON) * 1000000) / 1000000

      item.delivery_cubic_meter =
        Math.round(
          (((width_size_value / 10.0) *
            (length_size_value / 10.0) *
            (height_size_value / 10.0)) /
            1000000.0 +
            Number.EPSILON) *
            1000000
        ) / 1000000

      this.calculatePreDeliveryFee(item)
    },
    async calculatePreDeliveryFee(item) {
      let document = {
        delivery_type: this.delivery_type ? this.delivery_type : '',
        delivery_fee: 0.0,
        width_mm:
          item.size_type === 'MM'
            ? item.width_size_value
            : item.width_size_value * 10,
        length_mm:
          item.size_type === 'MM'
            ? item.length_size_value
            : item.length_size_value * 10,
        height_mm:
          item.size_type === 'MM'
            ? item.height_size_value
            : item.height_size_value * 10,
        weight_g:
          item.weight_type === 'G'
            ? item.weight_value
            : item.weight_value * 1000,
        is_ofm_delivery: item.is_ofm_delivery,
        is_extra_delivery_fee: false,
        is_click_and_collect: false,
        is_free: this.is_free,
        is_dropship: this.vendor_type === 'DropShip',
      }
      let resultDocument = await calculateDeliveryFee(document)
      console.log("calculateDeliveryFee" , resultDocument,item)
      item.fee = resultDocument.delivery_fee
      item.delivery_fee = resultDocument.delivery_fee
      item.is_ofm_delivery = resultDocument.is_ofm_delivery
      item.is_extra_shipping_fee = resultDocument.is_extra_delivery_fee
      item.is_click_and_collect = resultDocument.is_click_and_collect
    },
  },
}
</script>
